import { APIClient } from '@frontend/api-utils';
import { EntityType } from '@frontend/common';

export class BudgetEnumClient extends APIClient {
    public static readonly endpoint = '/budget-api/v1';

    public static async fetchBudgetEntityTypes(): Promise<EntityType[]> {
        const response = await this.fetch(`${this.endpoint}/budget-entity-types`);
        return await this.handleResponse<EntityType[]>(response);
    }
}
